import axios from "axios";
import { useState } from "react";
import { axiosInstanceForLambda } from "../library/Axios";

export const useLambdaFunctionUrl = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callLambdaFunctionUrl = async (config) => {
    const { url, payload, onSuccess, onError, method = "POST" } = config;

    try {
      setLoading(true);
      const response = await axiosInstanceForLambda({
        method: method,
        url: url,
        data: payload,
      });

      setLoading(false);

      if (onSuccess) {
        onSuccess(response.data);
      }

      return response.data;
    } catch (err) {
      setLoading(false);

      const statusCode = err?.response?.status;
      const errorMessage = err?.response?.data?.error || err?.message || "Something went wrong";
      setError(errorMessage);
      console.error("API Error:", {
        status: statusCode,
        message: errorMessage,
        response: err?.response,
      });

      if (onError) {
        onError({ status: statusCode, message: errorMessage, response: err?.response });
      }
    }
  };

  return { callLambdaFunctionUrl, loading, error };
};

